import SftPortfolioService from './SftPortfolioService';

export default class SftAuthService {
  public static ApplicationPath = window.ApplicationPath;

  public static authed: boolean = false;
  private isGuest = true;

  // get authorization params
  public getSessionParams() {
    const c = (window as any).Cookies.getJSON();
    return { sessionid: c.PHPSESSID ? c.PHPSESSID : 1234, loggedin: 3272 };
  }

  public init() {
    return this.auth()
      .then(() => {
        SftAuthService.authed = true;
      })
      .catch((err) => {
        // tslint:disable-next-line:no-console
        console.error('auth fail with' + err);
      });
  }

  private auth() {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('POST', window.ApplicationPath + '/WebServices/WebService.asmx/phpAuth', true);
      request.setRequestHeader('Accept', 'application/json');
      request.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
      request.withCredentials = true;
      request.onload = () => {
        if (request.status >= 200 && request.status < 400) {
          this.isGuest = true;

          const data = JSON.parse(request.responseText);
          if (data.d.error) {
            reject();
          } else {
            resolve(data.d);
          }
        } else {
          reject();
        }
      };

      request.onerror = () => {
        this.isGuest = true;
        reject();
      };

      request.send(JSON.stringify(this.getSessionParams()));
    });
  }
}
